/**
 * Shared Combobox listbox styles.
 *
 * Caps the popup height so long option lists scroll inside the popup
 * instead of stretching to fill the viewport (or, worse, escaping the
 * visible area when Fluent flips the popup above the trigger). Apply
 * via the Fluent `Combobox` `listbox` slot:
 *
 *   <Combobox listbox={{ className: styles.listbox }}>
 *
 * The scrollbar appearance itself is applied globally in `index.css`
 * (`[role="listbox"]`), so dropdowns without this slot still get the
 * app's thin scrollbar — they just won't have the height cap.
 *
 * Used by `SearchableCombobox` and by ad-hoc Combobox callers (e.g. the
 * permissions user search) so every combobox in the app has the same cap.
 */
import type { GriffelStyle } from '@fluentui/react-components';

export const COMBOBOX_LISTBOX_MAX_HEIGHT = '320px';

export const comboboxListboxStyles: GriffelStyle = {
  maxHeight: COMBOBOX_LISTBOX_MAX_HEIGHT,
  overflowY: 'auto',
  // Options that render rich content (e.g. a Persona with a long name +
  // email) can exceed the listbox width. Clip horizontally instead of
  // showing a horizontal scrollbar — keyboard navigation would otherwise
  // scroll the focused option sideways and clip its leading characters.
  overflowX: 'hidden',
};
